import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useUser } from "../contexts/UserContext";

export default function Header() {
  const { user, logout } = useUser();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="w-full bg-white border-b">
      {/* PC Navigation */}
      <nav className="hidden md:flex items-center justify-between px-6 py-2">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 min-w-0">
          <img src="/logo.png" alt="logo" className="w-8 h-8 object-contain" />
          <span className="text-xl font-bold whitespace-nowrap">A-Blind</span>
        </Link>

        {/* Menu */}
        <div className="flex gap-8 items-center text-sm font-medium">
          <Link to="/opportunities" className="hover:underline whitespace-nowrap">
            Opportunities
          </Link>

          <Link to="/artists" className="hover:underline whitespace-nowrap">
            Artists
          </Link>

          <Link to="/board" className="hover:underline whitespace-nowrap">
            Free Talk
          </Link>

          <Link to="/anonymous" className="hover:underline whitespace-nowrap">
            Anon Talk
          </Link>

          <Link to="/artluck" className="hover:underline whitespace-nowrap">
            Art-Luck
          </Link>
        </div>

        {/* User Area */}
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/mypage" className="font-semibold hover:underline whitespace-nowrap">
                {user.nickname || user.email}
              </Link>
              <button
                onClick={logout}
                className="ml-1 px-3 py-1 border rounded hover:bg-gray-200"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="px-3 py-1 border rounded hover:bg-black hover:text-white">
                Login
              </Link>
              <Link to="/signup" className="px-3 py-1 border rounded hover:bg-gray-300">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </nav>

      {/* Mobile Header */}
      <div className="flex md:hidden items-center justify-between px-3 py-2">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="logo" className="w-7 h-7 object-contain" />
          <span className="text-lg font-bold">A-Blind</span>
        </Link>

        <button onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <nav className="md:hidden bg-white border-b flex flex-col shadow">

          <button
            onClick={() => { navigate("/opportunities"); setMobileOpen(false); }}
            className="py-3 px-4 border-t text-base text-left"
          >
            Opportunities
          </button>

          <button
            onClick={() => { navigate("/artists"); setMobileOpen(false); }}
            className="py-3 px-4 border-t text-base text-left"
          >
            Artists
          </button>

          <button
            onClick={() => { navigate("/board"); setMobileOpen(false); }}
            className="py-3 px-4 border-t text-base text-left"
          >
            Free Talk
          </button>

          <button
            onClick={() => { navigate("/anonymous"); setMobileOpen(false); }}
            className="py-3 px-4 border-t text-base text-left"
          >
            Anon Talk
          </button>

          <button
            onClick={() => { navigate("/artluck"); setMobileOpen(false); }}
            className="py-3 px-4 border-t text-base text-left"
          >
            Art-Luck
          </button>

          {/* User */}
          {user ? (
            <>
              <button
                onClick={() => { navigate("/mypage"); setMobileOpen(false); }}
                className="py-3 px-4 border-t text-base text-left"
              >
                My Page
              </button>

              <button
                onClick={() => { logout(); setMobileOpen(false); }}
                className="py-3 px-4 border-t text-base text-left"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => { navigate("/login"); setMobileOpen(false); }}
                className="py-3 px-4 border-t text-base text-left"
              >
                Login
              </button>

              <button
                onClick={() => { navigate("/signup"); setMobileOpen(false); }}
                className="py-3 px-4 border-t text-base text-left"
              >
                Sign Up
              </button>
            </>
          )}
        </nav>
      )}
    </header>
  );
}
